<div class="display-units-container" [formGroup]="displayUnitsForm">
    <p class="description-text">{{'MENU_EDIT_PREFERENCES_DISPLAY_UNITS_DESCRIPTION' | translate}}</p>

    <div class="row row-height align-items-center">
        <div class="col-sm-3">
            <label>{{'PROJECT_UNITS' | translate}}</label>
        </div>
        <div class="col-sm-4">
            <mat-form-field appearance="outline" class="full-width col-sm-12">
                <mat-select formControlName="projectUnits">
                    <mat-option *ngFor="let unit of projectUnits" [value]="unit.id">
                        {{unit.description}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>

    <div class="row row-height align-items-center">
        <div class="col-sm-3">
            <label>{{'PRECISION' | translate}}</label>
        </div>
        <div class="col-sm-4 number-input-width pe-2">
            <mat-form-field appearance="outline" class="full-width col-sm-12">
                <input matInput formControlName="precision" [appNumericMask] = "numericFieldsConfig.precisionConfig" class="text-end" (blur)="clampToMin('precision', numericFieldsConfig.precisionConfig.min)">
            </mat-form-field>
        </div>
    </div>

    <fieldset class="recently-viewed-fieldset">
        <legend>{{'RECENTLY_VIEWED_ESTIMATE' | translate}}</legend>

        <div class="row row-height align-items-center">
            <div class="col-sm-3">
                <label>{{'ESTIMATE_DISPLAY' | translate}}</label>
            </div>
            <div class="col-sm-4 number-input-width">
                <mat-form-field appearance="outline" class="full-width col-sm-12">
                    <input matInput formControlName="estimateDisplay" [appNumericMask] = "numericFieldsConfig.estimateDisplayConfig" class="text-end" (blur)="clampToMin('estimateDisplay', numericFieldsConfig.estimateDisplayConfig.min)">
                </mat-form-field>
            </div>
        </div>

        <div class="row row-height align-items-center">
            <div class="col-sm-3">
                <label>{{'FAVOURITE_ESTIMATE_DISPLAY' | translate}}</label>
            </div>
            <div class="col-sm-4 number-input-width">
                <mat-form-field appearance="outline" class="full-width col-sm-12">
                    <input matInput formControlName="favouriteEstimateDisplay" [appNumericMask] = "numericFieldsConfig.favouriteEstimateDisplayConfig" class="text-end" (blur)="clampToMin('favouriteEstimateDisplay', numericFieldsConfig.favouriteEstimateDisplayConfig.min)">
                </mat-form-field>
            </div>
        </div>
    </fieldset>
</div>
